
function setCookie(name, value, minutes) {
  const expires = new Date();
  expires.setTime(expires.getTime() + minutes * 60 * 1000);

  // Formatea la cookie con el nombre, el valor y la fecha de vencimiento
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
}

export default setCookie;


//   

//   function deleteCookie(name) {
//     document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
//   }